const getStateSwitcherReducer = state => state.stateSwitcher;

const selectors = {
  selectedState: store => getStateSwitcherReducer(store).selectedState,
  states: store => getStateSwitcherReducer(store).states
};

export default { ...selectors };
